import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Tech Stack for Flutter App Development</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>Here is our tech stack for Flutter app development:</p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frameworks">
              <ul>
                <li> Material</li>
                <li>Cupertino</li>
                <li>MediaQuery</li>
                <li>Theme</li>
                <li>Localization</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Database">
              <ul>
                <li>Sqlite</li>
                <li>Firebase realtime database</li>                
                <li>Firestore</li>                
                <li>Firebase cloud storage</li>                              
              </ul>
            </Tab>
            <Tab eventKey="3" title="Libraries">
              <ul>
                <li>Firebase</li>
                <li>Get & provider</li>
                <li>Flutter local notifications</li>
                <li>Image picker</li>
                <li>Dio</li>
                <li>Url launcher</li>
                <li>Shared preferences</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Tools & Utilities">
              <ul>
                    <li>Android Studio</li>
                    <li>Flutter</li>
                    <li>Flutter SDK</li>
                    <li>Intellij idea</li>
                    <li>Dart plugins</li>
                    <li>Dart SDK</li>
                    <li>Version control tools</li>

              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Syncfusion charts</li>
                <li>Map</li>
                <li>Riverpod</li>
                <li>Place picker</li>
                <li>Flutter SVG</li>
                <li>Http</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
